// extracted by mini-css-extract-plugin
module.exports = {"today":"Day_today__1aaki","day":"Day_day__1oYmF","inactiveDay":"Day_inactiveDay__1nLOp","label":"Day_label__2fr0H","todayLabel":"Day_todayLabel__29ZA4"};